const EmptyLayout = ({ children }) => {
  return (
    <div className="flex h-auto min-h-screen w-full flex-col bg-white shadow">
      <div className="flex flex-1 shadow">{children}</div>
    </div>
  );
};

export default EmptyLayout;
